import request from '@/utils/request'
import axios from 'axios'
const ajax = {
  // 获取首页气泡消息数
  fszzInfo(id){
   return  request.post('/mall/mallmanage/index/getBubbleNum?fuserid='+id)
  },
  // 用户中心获取用户信息
  userInfo(data = {
    data: {},
    params: ''
  }) {
    return request.post('/mall/demand/userCenter/queryUserCenterInfo' + data.params, data.data)
  },

  // 用户中心查询商品收藏分页
  stockCollect(data = {
    data: {},
    params: ''
  }) {
    return request
      .post('/mall/demand/userCenter/queryStockCollect' + data.params, data.data)
  },
  // 用户中心关注店铺分页
  CollectSear(data = {
    data: {},
    params: ''
  }) {
    return request
      .post('/mall/demand/userCenter/queryStoreCollect' + data.params, data.data)
  },
  // 用户中心浏览记录分页
  RecordsSear(data = {
    data: {},
    params: ''
  }) {
    return request
      .post('/mall/demand/userCenter/queryBrowseRecords' + data.params, data.data)
    // return   request
    //    .post('/mall/demand/userCenter/browseRecordsPage' + data.params, data.data)
  },
  // 用户中心查询商品收藏分页-商品类别
  StockClass(data = {
    data: {},
    params: ''
  }) {
    return request
      .post('/mall/demand/userCenter/queryStockClass' + data.params, data.data)
  },
  // 用户中心 商品加入购物车
  ShoppingCart({
    data = {},
    params = '',
    token = ''
  }) {
    return request
      .post('/mall/stockmanage/mallstorestock/addShoppingCart?' + params, data)
  },
  // 奖励金查询
  DemandBonus(query = {}) {
    let params = Object.keys(query)
    params = params.map((item, index) => {
      if (params[index + 1]) {
        return `${item}=${query[item]}&`
      } else {
        return `${item}=${query[item]}`
      }
    }).join('')
    return request
      .post('/mall/demand/userCenter/userCenterDemandBonus?' + params)
  },
  // 修改用户头像-用户昵称
  userEdit(params = {}) {
    params = encodeURI(JSON.stringify(params))
    return request
      .post('/mall/demand/userCenter/modifyuserInfo?jsonStr=' + params)
  },
  // 删除浏览记录
  delBrowseRecords(params = '') {
    return request
      .post('/mall/demand/userCenter/delBrowseRecords?fBrowseIds=' + params)
  },
  // 跳转至店铺
  MallStoreNavigation(id) {
    return request.post(`/mall/storemanage/mallstore/queryMallStoreNavigation?FMallStoreId=${id}&FTemplateId=0`)
  },
  // 用户中心头像修改头像上传地址
  userEditupImg: '/mall/uploadImg'

}

export default ajax
